import React from 'react'
import { createUseStyles } from 'react-jss'
import { useIsAdmin } from '../../../redux/slices/session'
import { ListError, PageHeader } from '../../Common'
import CyclesFilter from '../../Common/CyclesFilter'
import usePracticeCycles from '../../Common/usePracticeCycles'
import Filters, { FIELDS_OPTIONS } from '../../Forms/Filters'
import { PAGE_SIZE } from '../../../lib/constants'
import useFilters from '../../Cycles/useFilters'
import BillingOrders from './BillingOrders'

const DEFAULT_FILTERS = {
  query: '',
  page: 1,
  perPage: PAGE_SIZE,
  billed: FIELDS_OPTIONS.billed[0].id,
}

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    '& > form:last-child': {
      flex: '1',
      minWidth: '135px',
    },
  },
})

export default function PracticeBillingOrders() {
  const isAdmin = useIsAdmin()
  const classes = useStyles()
  const [
    { error, pendingCycles, clearError },
    { practice, pending, practiceId },
  ] = usePracticeCycles()

  const {
    handleFilterChange,
    handlePageChange,
    conditions,
    setConditions,
  } = useFilters(DEFAULT_FILTERS)

  const { cycleId, page, query, billed } = conditions

  if (cycleId && !pending && !pendingCycles) {
    return (
      <div>
        <PageHeader
          title="Remote Billing Orders"
          subTitle={isAdmin && practice.name}
        />
        <div className={classes.container}>
          <CyclesFilter
            practiceId={practiceId}
            onSubmit={({ cycleId: newCycleId }) =>
              handleFilterChange({ cycleId: newCycleId })
            }
            currentCycleId={cycleId}
          />
          <Filters
            defaultValues={DEFAULT_FILTERS}
            currentValues={conditions}
            onSubmit={({ query: newQuery, billed: newBilled }) =>
              setConditions({
                ...conditions,
                query: newQuery,
                billed: newBilled,
                page: 1,
              })
            }
            placeholders={{
              query: 'Search by Name, DOB(YYYY-MM-DD), or MRN',
              billed: 'Billed status',
            }}
            showSearch
            showBilledStatus
          />
        </div>
        <BillingOrders
          cycleId={cycleId}
          onPageChange={handlePageChange}
          page={page}
          query={query}
          billed={billed}
          practiceId={practiceId}
        />
      </div>
    )
  }

  return (
    <div>
      {error && <ListError description={error.message} onClose={clearError} />}
    </div>
  )
}
